<script lang="ts" setup>
import { UserState } from '@/composition/users'
import { Menu01Icon } from '@gohighlevel/ghl-icons/24/outline'
import { UIAvatar } from '@gohighlevel/ghl-ui'

defineProps({
  src: {
    type: String,
    required: true,
  },
  size: {
    type: Number,
    default: 24,
  },
  className: {
    type: String,
    default: '',
  },
  active: {
    type: Boolean,
    default: false,
  },
})
</script>
<template>
  <div class="avatar-wrapper" :class="{ active: active }">
    <UIAvatar
      id="communities-ui-avatar-icon"
      :src="src || UserState?.state?.currentUser?.avatar"
      :size="size"
      :class="[className, { active: active }]"
    />
    <Menu01Icon class="menu-icon" :class="{ active: active }" />
  </div>
</template>

<style scoped>
.avatar-wrapper {
  position: relative;
  display: inline-block;
}

.menu-icon {
  position: absolute;
  bottom: -4px;
  right: -6px;
  height: 0.9rem;
  width: 0.9rem;
  color: white;

  background-color: #65676b;
  border-radius: 100%;
  padding: 1px;
  border: 2px solid var(--border);
}

.active .menu-icon {
  background-color: #242526;
  border-radius: 100%;
  border: 2px solid #242526;
  color: white;
  padding: 1px;
}

#communities-ui-avatar-icon {
  border: 2px solid var(--border);
}

#communities-ui-avatar-icon.active {
  border: 2px solid black;
}
</style>
